import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'programSearchFilter',
    standalone: false
})
export class ProgramSearchFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    if(!value) return value;
    if(!args) return value;

    args = args.toLowerCase();
    return value.filter(data =>{
      return JSON.stringify(data).toLowerCase().includes(args);
    })
  }

}
